import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import { Auth, I18n } from 'aws-amplify';
import PropTypes from 'prop-types';
import Tabs from '@material-ui/core/Tabs';
import { BrowserRouter, Route, Link } from 'react-router-dom';
import {
  TERM_VER,
  HEADER_VIEW_PATTERN,
  ADMIN_USER_TYPES,
  ACCOUNT_USER_CONFIRMATION_STATUS,
  ACCOUNT_USER_TYPE,
} from '../../configures/val.js';

import ServiceList from './servicelist.js';

import EditAddress from './editAddress.js';
import EditPassword from './editPassword.js';
import EditPersonalData from './editPersonalData.js';
import UserProfileView from './userprofileview.js';

import MierukaManagement from './mieruka/mierukamanagement.js';
import CruiseSetting from './mieruka/cruisesetting.js';

import InvoiceList from './invoice/invoiceList.js';

import PpaProductList from './ppa/productlist.js';
import PpaUserScreenSetting from './ppa/userScreenSetting.js';

import authCheck, { getCanIseeInvoiceList, fetchUserAccounts } from '../util/callApi.js';
import checkTermsVer from '../util/checkTermsVer.js';
import LapDialog from '../util/laplaceDialog.js';

import UserMenu from '../UserMenu/index.js';
import SwitchAccountMenu from '../SwitchAccountMenu/index.js';
import Dialog from '../common/Dialog/index.js';

import AccountManagement from '../../pages/AccountManagement/index.js';
import UserManagement from '../../pages/UserManagement/index.js';
import AccountAffiliationConfirmation from '../../pages/AccountAffiliationConfirmation/index.js';
import LicenseManagement from '../../pages/LicenseManagement/index.js';
import SolarProLicenseManagement from '../../pages/SolarProLicenseManagement/index.js';

import SolarPro from '../../pages/SolarPro/index.js';
import SolarProInstallerRelatedInfo from '../../pages/SolarProInstallerRelatedInfo/index.js';

const styles = {
  root: {
    flexGrow: 1,
    width: '100%',
  },
  flex: {
    flexGrow: 1,
    textAlign: 'right',
    marginRight: 40,
    fontSize: '0.9rem',
  },
  menuButton: {
    marginLeft: -12,
    marginRight: 20,
  },
};

const howToUseLaplaceId = 'https://www.lapsys.co.jp/products/laplace_id/#download';

class ButtonAppBar extends React.Component {
  static ACCOUNT_INDEX_LOCAL_STORAGE_KEY = 'accountIndex';
  static TAB_CLASS_NAME = {
    DEFAULT: 'L_link_tab',
    ACTIVE: 'L_link_tab headerSelected',
  };
  static TAB_NAME = {
    USER_PROF: 'userProf',
    INVOICE_LIST: 'invoiceList',
    SERVICE_LIST: 'serviceList',
    PPA_PRODUCT_LIST: 'ppaProductList',
    PPA_USERVIEW_SETTING: 'ppaUserviewSetting',
    ACCOUNT_MANAGEMENT: 'accountManagement',
    USER_MANAGEMENT: 'userManagement',
    LICENSE_MANAGEMENT: 'licenseManagement',
  };
  constructor(props) {
    super(props);
    this.state = {
      userData: null,
      open: false,
      termVerError: false,
      headerViewPattern: HEADER_VIEW_PATTERN.DEFAULT,
      activeTab: ButtonAppBar.TAB_NAME.USER_PROF,
      canSeeInvoiceList: false,
      supplierId: null,
      isUserMenuOpen: false,
      isSwitchAccountMenuOpen: false,
      accounts: [],
      selectedAdministeringAccountIndex:
        JSON.parse(localStorage.getItem(ButtonAppBar.ACCOUNT_INDEX_LOCAL_STORAGE_KEY)) || 0,
      isAlertDialogOpen: false,
      alertDialogContent: '',
    };
  }
  updateUserProfile = (data) => {
    this.setState({
      userData: data,
    });
  };
  updateHeaderViewPattern = (pattern) => {
    this.setState({
      headerViewPattern: pattern,
    });
  };
  updateActiveTab = (name) => {
    this.setState({
      activeTab: name,
    });
  };
  updateSupplierId = (supplierId) => {
    this.setState({
      supplierId: supplierId,
    });
  };
  checkUser = () => {
    const that = this;
    return Auth.currentAuthenticatedUser()
      .then((user) => {
        if (!that._isMounted) {
          return;
        }
        Auth.userAttributes(user)
          .then((attributes) => {
            const userData = {};
            attributes.forEach(({ Name, Value }) => {
              userData[Name] = Value;
            });
            this.setState({
              userData,
            });
          })
          .catch((attrErr) => {
            this.setState({
              userData: null,
            });
            // トークンが死んでいる可能性がある
            Auth.signOut().then(() => this.props.authProps.onStateChange('signIn'));
          });
      })
      .catch((err) => {
        if (!that._isMounted) {
          return;
        }
        this.setState({
          userData: null,
        });
        Auth.signOut().then(() => this.props.authProps.onStateChange('signIn'));
      });
  };
  async canSeeBillingList() {
    try {
      const ret = await getCanIseeInvoiceList();
      return ret;
    } catch (err) {
      return false;
    }
  }
  async closeTermVerError(that) {
    const user = await Auth.currentAuthenticatedUser();
    const authProp = {
      user,
      href: this.state.href,
    };
    that.props.authProps.onStateChange('reagreeTermsDocs', authProp);
    this.setState({
      termVerError: false,
    });
    return;
  }
  /**
   * 所属アカウント情報を状態変数にセットする
   */
  async setAccounts() {
    if (!this.state.userData?.sub) return;
    const res = await fetchUserAccounts(this.state.userData.sub);
    if (!res.ok) return;
    // 利用するのは確認状況が「完了」のアカウントのみ
    const accounts = res.data.accounts.filter(
      ({ confirmationStatus }) => confirmationStatus === ACCOUNT_USER_CONFIRMATION_STATUS.CONFIRMED
    );
    if (!accounts.length) return;
    this.setState({
      accounts: accounts,
    });
  }
  componentWillUnmount() {
    this._isMounted = false;
  }
  async componentDidMount() {
    this._isMounted = true;
    this.checkUser();
    try {
      const authRet = await authCheck();
      if (authRet.result === 'NG') {
        window.history.pushState('', '', '/');
        this.props.authProps.onStateChange('signIn');
        return;
      }
      const isLowVer = checkTermsVer(authRet.data, 'custom:agreed_term', TERM_VER, 'ver');
      if (isLowVer) {
        this.setState({
          termVerError: true,
          href: window.location,
        });
        return;
      }
    } catch (error) {
      console.log('error == componentDidMount == header.js');
      console.log(error);
    }
    const canSeeInvoice = await this.canSeeBillingList();
    // result が 'NG' のときリロードを促すアラート
    if (canSeeInvoice.result === 'NG') {
      alert(I18n.get('Failed to confirm access to invoice service. Please reload the screen.'));
      this.setState({
        canSeeInvoiceList: false,
        termVerError: false,
      });
      return;
    }
    this.setState({
      canSeeInvoiceList: canSeeInvoice.data.result,
      termVerError: false,
    });
  }
  async componentDidUpdate(prevProps, prevState) {
    // ユーザ情報が更新されていればアカウント情報を取得する
    if (prevState.userData?.sub !== this.state.userData?.sub) {
      await this.setAccounts();
    }
    if (
      prevState.selectedAdministeringAccountIndex !== this.state.selectedAdministeringAccountIndex
    ) {
      localStorage.setItem(
        ButtonAppBar.ACCOUNT_INDEX_LOCAL_STORAGE_KEY,
        JSON.stringify(this.state.selectedAdministeringAccountIndex)
      );
    }
  }
  async isTermVerError() {
    const authRet = await authCheck();
    return checkTermsVer(authRet.data, 'custom:agreed_term', TERM_VER, 'ver');
  }
  async controlTransition(e, href) {
    e.preventDefault();
    const ret = await this.isTermVerError();
    if (ret) {
      this.setState({
        termVerError: true,
        href,
      });
      return false;
    }
    window.location.href = href;
  }
  signOut = () => {
    Auth.signOut().then(() => {
      window.history.pushState('', '', '/');
      this.props.authProps.onStateChange('signIn');
    });
  };
  openUserMenu = () => {
    this.setState({
      isUserMenuOpen: true,
    });
  };
  closeUserMenu = () => {
    this.setState({
      isUserMenuOpen: false,
    });
  };
  switchUserMenuVisible = () => {
    if (this.state.isSwitchAccountMenuOpen) {
      this.closeSwitchAccountMenu();
    } else {
      this.setState({
        isUserMenuOpen: !this.state.isUserMenuOpen,
      });
    }
  };
  openSwitchAccountMenu = () => {
    this.closeUserMenu();
    this.setState({
      isSwitchAccountMenuOpen: true,
    });
  };
  closeSwitchAccountMenu = () => {
    this.setState({
      isSwitchAccountMenuOpen: false,
    });
  };
  switchAccount = (index) => {
    this.setState({ selectedAdministeringAccountIndex: index });
    this.closeSwitchAccountMenu();
  };
  openAlertDialog = () => {
    this.closeUserMenu();
    this.setState({
      isAlertDialogOpen: true,
    });
  };
  closeAlertDialog = () => {
    this.setState({
      isAlertDialogOpen: false,
    });
  };
  setAlertDialogContent = (content) => {
    this.setState({
      alertDialogContent: content,
    });
  };
  getDefaultHeaderInfo = () => {
    const title = I18n.get('My page');
    const tabItems = [
      {
        to: '/',
        name: ButtonAppBar.TAB_NAME.USER_PROF,
        text: I18n.get('User profile'),
      },
      {
        to: '/servicelist',
        name: ButtonAppBar.TAB_NAME.SERVICE_LIST,
        text: I18n.get('Service list'),
      },
    ];
    if (this.state.canSeeInvoiceList) {
      tabItems.push({
        to: '/invoicelist',
        name: ButtonAppBar.TAB_NAME.INVOICE_LIST,
        text: I18n.get('Invoices'),
      });
    }

    return { title: title, tabItems: tabItems };
  };
  getPpaHeaderInfo = () => {
    const title = I18n.get('User view management');
    const tabItems = [
      {
        to: '/ppa/productlist',
        name: ButtonAppBar.TAB_NAME.PPA_PRODUCT_LIST,
        text: I18n.get('Product list'),
      },
      {
        to: '/ppa/userviewsetting',
        name: ButtonAppBar.TAB_NAME.PPA_USERVIEW_SETTING,
        text: I18n.get('User screen setting'),
      },
    ];

    return { title: title, tabItems: tabItems };
  };
  getManagementHeaderInfo = () => {
    const title = I18n.get('Management');
    const tabItems = ['account', 'user', 'license'].map((target) => {
      return {
        to: `/management/${target}`,
        name: ButtonAppBar.TAB_NAME[`${target.toUpperCase()}_MANAGEMENT`],
        text: `${I18n.get(target.charAt(0).toUpperCase() + target.slice(1))}`,
      };
    });

    return { title: title, tabItems: tabItems };
  };
  renderHeader = () => {
    let title;
    let tabItems;
    switch (this.state.headerViewPattern) {
      case HEADER_VIEW_PATTERN.PPA:
        ({ title, tabItems } = this.getPpaHeaderInfo());
        break;
      case HEADER_VIEW_PATTERN.MANAGEMANT:
        ({ title, tabItems } = this.getManagementHeaderInfo());
        break;
      case HEADER_VIEW_PATTERN.CONFIRMATION:
        return <span className='L_headerTitle'>{I18n.get('Laplace ID')}</span>;
      case HEADER_VIEW_PATTERN.DEFAULT:
      default:
        ({ title, tabItems } = this.getDefaultHeaderInfo());
    }

    const { classes } = this.props;
    const administeringAccounts = this.state.accounts.filter(({ selfType }) =>
      ADMIN_USER_TYPES.includes(selfType)
    );

    return (
      <>
        <span className='L_headerTitle'>{title}</span>
        <Tabs
          indicatorColor='primary'
          textColor='primary'
          scrollable
          scrollButtons='off'
          className={'L_tabBarBack'}
          classes={{ root: classes.tabsRoot }}
        >
          {tabItems.map(({ to, name, text }) => (
            <Link
              to={to}
              className={
                ButtonAppBar.TAB_CLASS_NAME[this.state.activeTab === name ? 'ACTIVE' : 'DEFAULT']
              }
              key={name}
            >
              {text}
            </Link>
          ))}
        </Tabs>
        <div className='headerRightArea'>
          <div className='howToUseLaplaceId'>
            <a href={howToUseLaplaceId} target='_blank' rel='noopener noreferrer'>
              {I18n.get('How to use')}
            </a>
          </div>
          <div className='userIcon' onClick={this.switchUserMenuVisible}></div>
        </div>
        <UserMenu
          onClose={this.closeUserMenu}
          userData={this.state.userData}
          signOut={this.signOut}
          open={this.state.isUserMenuOpen}
          administeringAccountCount={administeringAccounts.length}
          openSwitchAccountMenu={this.openSwitchAccountMenu}
        />
        <SwitchAccountMenu
          open={this.state.isSwitchAccountMenuOpen}
          onClose={this.closeSwitchAccountMenu}
          switchAccount={this.switchAccount}
          accounts={administeringAccounts}
        />
      </>
    );
  };
  render() {
    const administeringAccounts = this.state.accounts.filter(({ selfType }) =>
      ADMIN_USER_TYPES.includes(selfType)
    );

    return (
      <div className={this.props.classes.root}>
        <BrowserRouter>
          <div>
            <AppBar style={{ backgroundColor: '#13367c' }} position='static'>
              <Toolbar className={'L_menuBarBack'}>{this.renderHeader()}</Toolbar>
              <Dialog
                open={this.state.isAlertDialogOpen}
                onClose={this.closeAlertDialog}
                content={this.state.alertDialogContent}
                type='alert'
                onAccept={this.closeAlertDialog}
              />
            </AppBar>
            <div className='userProfile'>
              {
                // 完全一致にししたいのでexactを使うようにしています
              }
              {
                // propsを渡したいのでcomponentではなくrenderを使うようにしています
              }
              <Route
                exact
                path='/'
                render={() => (
                  <UserProfileView
                    userProf={this.state.userData}
                    authStateChange={this.props.authProps.onStateChange}
                    updateHeader={() => {
                      this.updateHeaderViewPattern(HEADER_VIEW_PATTERN.DEFAULT);
                      this.updateActiveTab(ButtonAppBar.TAB_NAME.USER_PROF);
                    }}
                    accounts={this.state.accounts}
                  />
                )}
              />
              <Route
                exact
                path='/updateaddress'
                render={(props) => (
                  <EditAddress
                    {...props}
                    authProps={this.props.authProps}
                    userAttribute
                    className='userProfile'
                    updateHeader={() => {
                      this.updateHeaderViewPattern(HEADER_VIEW_PATTERN.DEFAULT);
                      this.updateActiveTab(ButtonAppBar.TAB_NAME.USER_PROF);
                    }}
                    amIPrimaryAdmin={Boolean(
                      administeringAccounts.filter(
                        ({ selfType }) => selfType === ACCOUNT_USER_TYPE.PRIMARY_ADMIN
                      ).length
                    )}
                  />
                )}
              />
              <Route
                exact
                path='/updatepass'
                render={(props) => (
                  <EditPassword
                    {...props}
                    authStateChange={this.props.authProps.onStateChange}
                    className='userProfile'
                    updateHeader={() => {
                      this.updateHeaderViewPattern(HEADER_VIEW_PATTERN.DEFAULT);
                      this.updateActiveTab(ButtonAppBar.TAB_NAME.USER_PROF);
                    }}
                  />
                )}
              />
              <Route
                exact
                path='/updateprofile'
                render={(props) => (
                  <EditPersonalData
                    {...props}
                    update={this.updateUserProfile}
                    userProf={this.state.userData}
                    authStateChange={this.props.authProps.onStateChange}
                    updateHeader={() => {
                      this.updateHeaderViewPattern(HEADER_VIEW_PATTERN.DEFAULT);
                      this.updateActiveTab(ButtonAppBar.TAB_NAME.USER_PROF);
                    }}
                  />
                )}
              />
              <Route
                exact
                path='/mierukamanage'
                render={(props) => (
                  <MierukaManagement authStateChange={this.props.authProps.onStateChange} />
                )}
              />
              <Route
                exact
                path='/mierukacruise'
                render={(props) => (
                  <CruiseSetting authStateChange={this.props.authProps.onStateChange} />
                )}
              />
              <Route
                exact
                path='/invoicelist'
                render={(props) => (
                  <InvoiceList
                    updateHeader={() => {
                      this.updateHeaderViewPattern(HEADER_VIEW_PATTERN.DEFAULT);
                      this.updateActiveTab(ButtonAppBar.TAB_NAME.INVOICE_LIST);
                    }}
                    authStateChange={this.props.authProps.onStateChange}
                  />
                )}
              />
              <Route
                exact
                path='/servicelist'
                render={(props) => (
                  <ServiceList
                    updateHeader={() => {
                      this.updateHeaderViewPattern(HEADER_VIEW_PATTERN.DEFAULT);
                      this.updateActiveTab(ButtonAppBar.TAB_NAME.SERVICE_LIST);
                    }}
                    authStateChange={this.props.authProps.onStateChange}
                    accounts={this.state.accounts}
                  />
                )}
              />
              <Route
                exact
                path='/servicelist/solarpro'
                render={() => (
                  <SolarPro
                    updateHeader={() => {
                      this.updateHeaderViewPattern(HEADER_VIEW_PATTERN.DEFAULT);
                      this.updateActiveTab(ButtonAppBar.TAB_NAME.SERVICE_LIST);
                    }}
                    accounts={this.state.accounts}
                  />
                )}
              />
              <Route
                exact
                path='/servicelist/solarpro/installer-related-info'
                render={() => (
                  <SolarProInstallerRelatedInfo
                    accounts={this.state.accounts}
                    updateHeader={() => {
                      this.updateHeaderViewPattern(HEADER_VIEW_PATTERN.DEFAULT);
                      this.updateActiveTab(ButtonAppBar.TAB_NAME.SERVICE_LIST);
                    }}
                  />
                )}
              />
              <Route
                exact
                path='/ppa/productlist'
                render={() => (
                  <PpaProductList
                    authStateChange={this.props.authProps.onStateChange}
                    updateHeader={() => {
                      this.updateHeaderViewPattern(HEADER_VIEW_PATTERN.PPA);
                      this.updateActiveTab(ButtonAppBar.TAB_NAME.PPA_PRODUCT_LIST);
                    }}
                    supplierId={this.state.supplierId}
                    updateSupplierId={this.updateSupplierId}
                    signOut={this.signOut}
                  />
                )}
              />
              <Route
                exact
                path='/ppa/userviewsetting'
                render={() => (
                  <PpaUserScreenSetting
                    updateHeader={() => {
                      this.updateHeaderViewPattern(HEADER_VIEW_PATTERN.PPA);
                      this.updateActiveTab(ButtonAppBar.TAB_NAME.PPA_USERVIEW_SETTING);
                    }}
                    authStateChange={this.props.authProps.onStateChange}
                    supplierId={this.state.supplierId}
                    signOut={this.signOut}
                  />
                )}
              />
              <Route
                exact
                path='/management/account'
                render={() => (
                  <AccountManagement
                    updateHeader={() => {
                      this.updateHeaderViewPattern(HEADER_VIEW_PATTERN.MANAGEMANT);
                      this.updateActiveTab(ButtonAppBar.TAB_NAME.ACCOUNT_MANAGEMENT);
                    }}
                    accountId={
                      administeringAccounts[this.state.selectedAdministeringAccountIndex]?.id
                    }
                    userSub={this.state.userData?.sub}
                  />
                )}
              />
              <Route
                exact
                path='/management/user'
                render={() => (
                  <UserManagement
                    updateHeader={() => {
                      this.updateHeaderViewPattern(HEADER_VIEW_PATTERN.MANAGEMANT);
                      this.updateActiveTab(ButtonAppBar.TAB_NAME.USER_MANAGEMENT);
                    }}
                    accountId={
                      administeringAccounts[this.state.selectedAdministeringAccountIndex]?.id
                    }
                  />
                )}
              />
              <Route
                exact
                path='/management/license'
                render={() => (
                  <LicenseManagement
                    updateHeader={() => {
                      this.updateHeaderViewPattern(HEADER_VIEW_PATTERN.MANAGEMANT);
                      this.updateActiveTab(ButtonAppBar.TAB_NAME.LICENSE_MANAGEMENT);
                    }}
                    accountId={
                      administeringAccounts[this.state.selectedAdministeringAccountIndex]?.id
                    }
                  />
                )}
              />
              <Route
                exact
                path='/management/license/solarpro'
                render={() => (
                  <SolarProLicenseManagement
                    updateHeader={() => {
                      this.updateHeaderViewPattern(HEADER_VIEW_PATTERN.MANAGEMANT);
                      this.updateActiveTab(ButtonAppBar.TAB_NAME.LICENSE_MANAGEMENT);
                    }}
                    accountId={
                      administeringAccounts[this.state.selectedAdministeringAccountIndex]?.id
                    }
                  />
                )}
              />
              <Route
                exact
                path='/confirmation'
                render={() => (
                  <AccountAffiliationConfirmation
                    updateHeader={() => {
                      this.updateHeaderViewPattern(HEADER_VIEW_PATTERN.CONFIRMATION);
                    }}
                    userSub={this.state.userData?.sub}
                  />
                )}
              />
            </div>
          </div>
        </BrowserRouter>
        <LapDialog
          title={''}
          contentElem={
            <div>
              <p>{I18n.get('Terms of Service is updated.')}</p>
              <p>{I18n.get('Please reconfirm it.')}</p>
            </div>
          }
          firstButtonText={'OK'}
          firstButtonFunc={() => this.closeTermVerError(this)}
          open={this.state.termVerError}
          toClose={() => {
            return;
          }}
        />
      </div>
    );
  }
}
ButtonAppBar.propTypes = {
  classes: PropTypes.object.isRequired,
};
export default withStyles(styles)(ButtonAppBar);
